<app-encabezado></app-encabezado>
<router-outlet></router-outlet>
